
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/tutorials/how-to-compile-mm2-from-source",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/tutorials/how-to-compile-mm2-from-source/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/tutorials/how-to-compile-mm2-from-source"])
      });
    }
  